import { Typography } from '@curology/ui-components-web/react/Typography';
import React, { useEffect, useState } from 'react';

import { AnalyticsEvent, trackEvent } from '@/utils/analytics';
import { type SwapUpsell } from '@/utils/shopify/types/swapUpsell';

import DeepCleanseRxModal from './acneMultiRxUpsellComponents/deepCleanseRxModal';
import Disclaimers from './acneMultiRxUpsellComponents/disclaimers';
import FooterCtas from './acneMultiRxUpsellComponents/footerCtas';
import ProductCarousel from './acneMultiRxUpsellComponents/productCarousel';
import ProductComparison from './acneMultiRxUpsellComponents/productComparison';
import RoutineProducts from './acneMultiRxUpsellComponents/routineProducts';

const AcneMultiRxUpsell = ({ swapUpsell }: { swapUpsell: SwapUpsell }) => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    trackEvent(AnalyticsEvent.UPSELL_VIEWED, {
      upsell: 'DEEP_CLEANSE_UPSELL',
    });
  }, []);

  return (
    <>
      <div className="cur-max-w-[550px] cur-mx-auto cur-px-6 cur-pt-8 cur-pb-25 cur-w-full">
        <Typography className="cur-text-surface-brand" size="h2">
          Special offer
        </Typography>
        <Typography className="cur-mb-4" size="h2">
          Upgrade your cleanser with Deep Cleanse<sup>Rx</sup>
        </Typography>
        <ProductComparison />
        <Typography className="cur-my-4" size="h2">
          <span className="cur-text-surface-brand">Tackle acne</span> from all
          angles, starting from deep in your pores
        </Typography>
        <ProductCarousel />
        <Typography className="cur-my-4" size="h2">
          Your routine, leveled up
        </Typography>
        <RoutineProducts />
        <Disclaimers discountAmountInCents={1000} setShowModal={setShowModal} />
      </div>
      <FooterCtas swapUpsell={swapUpsell} />
      <DeepCleanseRxModal setShowModal={setShowModal} showModal={showModal} />
    </>
  );
};

export default AcneMultiRxUpsell;
